import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SpesielleBegrensningerBruksklasse } from "../../RouteDescription/SpesielleBegrensningerBruksklasse";
import { RoadFeaturesWithBruksklasse } from "../../../services/RuteplanAPI";

export default function SpesielleBegrensningerBruksklasseListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  const roadFeatureResponse = props.roadFeatureResponse as RoadFeaturesWithBruksklasse;
  
  return(
    <>
    {roadFeatureResponse && roadFeatureResponse.spesielleBegrensningerBruksklasse && roadFeatureResponse.spesielleBegrensningerBruksklasse.length > 0 && (
      <>
        <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Spesielle begrensninger bruksklasse (${roadFeatureResponse.spesielleBegrensningerBruksklasse.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <SpesielleBegrensningerBruksklasse roadFeatures={roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
      </>
    )}
    
    </>
  )
}